import React, { useState } from 'react'

const InternalReports = () => {

    const [loading, setLoading] = useState(true);
    return (
        <>


            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    {loading ? <h1 className="h2"><i class="fa-solid fa-spinner fa-spin"></i></h1> : <h1 className="h2">Internal Reports</h1>}

                </div>
                <div>

                    <iframe
                        src="https://lookerstudio.google.com/embed/reporting/a7f76966-edb0-4158-9707-4ce1a5844a5f/page/p_r71n7omi5c"
                        onLoad={() => setLoading(false)}
                        width={'1225'}
                        height={'1000'}
                        style={{ display: loading ? 'none' : 'block' }}
                    />
                </div>
            </main>
        </>
    )

}

export default InternalReports;